import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDoubleArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.33333 6.66667L14 2M14 6V2H10M6.66667 9.33333L2 14M2 10L2 14H6",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgDoubleArrow;
